<main>
  <div class="container container-width">
    <div class="topheadtitle">
      <h4>Agency Annual Report @if (showReportResults) {
        <span> - {{selectedYear}}</span>
      }</h4>
    </div>

    @if (!showReportResults) {
      <div class="form-box w-100 d-flex p-2">
        <label for="selectYear" class="mr-1">Report Year</label>
        <select [(ngModel)]="selectedYear" id="selectYear" title="select year" class="option-d ml-auto">
          @for (years of listOfYearsOptions; track years) {
            <option [value]="years">{{years}}</option>
          }
        </select>
      </div>
      <div class="mt-3">
        <button type="button" class="btn btn-primary btn-sm" (click)="getAnnualSummary()">Generate Report</button>
        <button type="button" class="btn btn-primary btn-sm ml-3" (click)="selectedYear = 2025">Reset</button>
      </div>
    }

    @if (showReportResults) {
      <div class="table-container">
        @if (outPut.length > 0) {
          <button type="button" class="btn btn-primary btn-sm mb-1" (click)="excelExport()">
            Export To Excel
          </button>
        }
        <table class="table">
          <caption>Agency Annual Report</caption>
          <thead>
            <tr>
              <th scope="col">Month/Year</th>
              <th scope="col">DNR</th>
              <th scope="col">Police</th>
              <th scope="col">Sheriff</th>
              <th scope="col">State Patrol</th>
              <th scope="col">Other</th>
              <th scope="col">Total Submitted</th>
            </tr>
          </thead>
          <tbody>
            @for (item of getItems(); track item) {
              <tr>
                <td>{{item.date}}</td>
                <td>{{item.dnr}}</td>
                <td>{{item.police}}</td>
                <td>{{item.sheriff}}</td>
                <td>{{item.statePatrol}}</td>
                <td>{{item.other}}</td>
                <td>{{item.total}}</td>
              </tr>
            }
            <tr>
              <th id="totalDate" scope="col">{{total.date}}</th>
              <th id="totalDnr" scope="col">{{total.dnr}}</th>
              <th id="totalPolice" scope="col">{{total.police}}</th>
              <th id="totalSheriff" scope="col">{{total.sheriff}}</th>
              <th id="totalStatePatrol" scope="col">{{total.statePatrol}}</th>
              <th id="totalOther" scope="col">{{total.other}}</th>
              <th id="totalFinal" scope="col">{{total.total}}</th>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <span>{{outPut.length}} items found, displaying {{getCurrentPageTotal()}} of {{outPut.length}}</span>
          </div>
          <ngb-pagination [collectionSize]="outPut.length" [(page)]="currentPage" [ellipses]="true" [maxSize]="10"
            (pageChange)="onPageChange(currentPage)" [pageSize]="10" [boundaryLinks]="true"
          aria-label="Annual report pagination"></ngb-pagination>
          <br />
          <button type="button" class="btn btn-outline-primary" (click)="showReportResults = false;">
            Go back to previous page
          </button>
        </div>
      </div>
    }
  </div>
</main>